import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
import { costRows } from '../data/comparaciones';
import { Emoji } from './Emoji';
export function CostoDeNoTenerlo() {
  return <section className="w-full bg-canvas py-14 sm:py-16" data-id="element-49" data-mp="2f7z3npcar9mj">
      <div className="mx-auto w-full max-w-[680px] px-4 text-center sm:px-6 lg:max-w-[980px]" data-id="element-50" data-mp="2f7gyg37npl2h">
        <h2 className="inline-flex flex-wrap items-center justify-center gap-2 font-display text-[clamp(1.5rem,6vw,2.25rem)] font-extrabold leading-[1.08] tracking-tight text-ink-900" data-id="element-51" data-mp="2k5ih4n167idf">
          <Emoji symbol="⚖️" className="text-3xl" data-id="element-52" data-mp="2a9xj0zz8328y" />
          ¿Cuánto te cuesta NO tenerlo?
        </h2>

        <ul className="mt-9 grid gap-3 text-left lg:grid-cols-2" data-id="element-53" data-mp="1wisg9p0k5tue">
          {costRows.map(row => <li key={row.situation} className="rounded-2xl border border-red-200 bg-white px-4 py-4 shadow-card sm:px-5 sm:py-5" data-id="element-54" data-mp="20jm64nxk9ipx">
              <p className="flex items-start gap-2.5 text-[14px] font-medium text-ink-700 sm:text-[15px]" data-id="element-55" data-mp="1rinzdxvqmx3n">
                <Emoji symbol={row.emoji} className="mt-0.5" data-id="element-56" data-mp="1bg79mkb6riqp" />
                <span className="min-w-0" data-id="element-57" data-mp="16i5prx5xrfe6">{row.situation}</span>
              </p>
              <p className="mt-3 flex items-start gap-2 text-[14px] font-bold text-red-600 sm:text-[15px]" data-id="element-58" data-mp="16k9v8jjhgmgk">
                <ArrowDownIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-59" data-mp="1kfkh57fr1x8s" />
                <span className="min-w-0" data-id="element-60" data-mp="rshlqo6de2mr">{row.cost}</span>
              </p>
            </li>)}
        </ul>

        <p className="mt-11 font-display text-[clamp(1.25rem,5vw,1.875rem)] font-extrabold tracking-tight text-ink-900" data-id="element-61" data-mp="nsz17tigntkg">
          El MegaPack Cocina Proteica Lista cuesta menos que dos semanas de
          delivery.
        </p>
        <p className="mt-3 font-display text-lg font-bold text-celeste-700 sm:text-xl" data-id="element-62" data-mp="wq9gdpyeg2un">
          Y dura para siempre.
        </p>
      </div>
    </section>;
}